export class MediCalcBy {
    static Balance = 1;
    static Standard = 2;


    value: number;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}